module.exports = "<ngb-datepicker  style=\"direction: ltr;\" [(ngModel)]=\"model\" (select)=\"changedate()\" class=\"rtl\"></ngb-datepicker>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-date/islamic.component.html
// module id = ./src/app/components/app-date/islamic.component.html
// module chunks = main